export default __webpack_public_path__ + "c43ed9c.svg";